import { render, staticRenderFns } from "./Level4-1.vue?vue&type=template&id=356dbaa5&scoped=true&"
import script from "./Level4-1.vue?vue&type=script&lang=js&"
export * from "./Level4-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356dbaa5",
  null
  
)

export default component.exports